import { Input as InputPrimitive } from "@base-ui/react/input";
import type { ComponentProps } from "react";

import {
  focusRing,
  invalidInteraction,
} from "@/components/ui/interaction-variants";
import { cn } from "@/lib/shared/utils";

function Input({ className, type, ...props }: ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        "h-8 w-full min-w-0 rounded-md border border-transparent bg-secondary px-2 py-1 text-sm transition-colors ease-out-expo file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm/relaxed file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 md:text-sm/relaxed",
        focusRing,
        invalidInteraction,
        className,
      )}
      {...props}
    />
  );
}

export { Input };
